import { patch } from "@src/appV2/api/parsedApi";
import { environmentConfig } from "@src/appV2/environment";
import { APP_V2_APP_EVENTS } from "@src/appV2/lib/analytics";
import { useMutation } from "@tanstack/react-query";
import { z } from "zod";

const updatePushTokenBodySchema = z.object({
  pushToken: z.string(),
  platform: z.string(),
});

const updatePushTokenResponseSchema = z.object({}).passthrough();

interface UseUpdatePushTokenParams {
  userId: string;
}

export function useUpdatePushToken(params: UseUpdatePushTokenParams) {
  const { userId } = params;

  return useMutation({
    mutationFn: async (data: { pushToken: string; platform: string }) => {
      const response = await patch({
        url: `${environmentConfig.REACT_APP_BASE_API_URL}/workplaceUser/${userId}/pushToken`,
        data,
        bodySchema: updatePushTokenBodySchema,
        responseSchema: updatePushTokenResponseSchema,
      });

      return response.data;
    },
    meta: {
      logErrorMessage: APP_V2_APP_EVENTS.UPDATE_PUSH_TOKEN_FAILURE,
    },
  });
}
